import * as yup from 'yup';

export const schema = yup.object({
	phone: yup
		.string()
		.required('Telefon numarası zorunludur')
		.min(10, 'Telefon numarasını eksiksiz doldurmalısınız')
		.matches(/^[0-9]+$/, 'Geçerli bir telefon numarası giriniz'),
	password: yup
		.string()
		.required('Şifre zorunludur')
		.min(6, 'Şifre en az 6 karakter olmalıdır')
		.matches(/^[0-9]{6}$/, 'Şifre sadece sayılardan oluşmalıdır')
		.test('unique', 'Tüm sayılar aynı olmamalı', value => {
			if (!value) return true;
			return !value.split('').every(char => char === value[0]);
		})
		.test('sequential', '123456 gibi ardışık sayılar kullanılamaz', value => {
			if (!value || value.length < 6) return true;
			const ascending = '123456';
			const descending = '654321';
			return !ascending.includes(value) && !descending.includes(value);
		})
});
